import Component from './OtherProducts'

export default Component
